import {
  Navigation,
  Swiper,
  Grid,
} from "./swiperConfig";

const DEFAULT_CONFIG_MAIN_ARTICLES = {
  spaceBetween: 24,
  speed: 900,
  allowTouchMove: false,
  watchSlidesProgress: true,
  slideVisibleClass: "article-card-visible",
  breakpoints: {
    320: {
      slidesPerView: 1,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    900: {
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
    1146: {
      slidesPerView: 3,
      grid: {
        rows: 2,
        fill: "row",
      },
    },
  },
};

function _getNavigation(element) {
  const prevElement = element.parentNode?.querySelector(".slider-btn.left");
  const nextElement = element.parentNode?.querySelector(".slider-btn.right");

  const navigation = ((prevElement || nextElement) ? {
    navigation: {
      ...(nextElement ? { nextEl: nextElement } : {}),
      ...(prevElement ? { prevEl: prevElement } : {}),
    },
  } : {});
  return {
    ...(navigation.navigation ? { modules: [Grid, Navigation] } : {}),
    ...navigation,
  };
}

/**
 * @param {object | string} element элемент, в который подключаем свайпер или css-query для получения такого элемента
 * @returns {object} объект свайпера
 */
function _getSwiper(element, customConfig = {}) {
  const navigation = _getNavigation(element);
  const config = {
    ...DEFAULT_CONFIG_MAIN_ARTICLES,
    ...navigation,
    ...customConfig,
  };

  return new Swiper(element, config);
}

/**
 * Добавляет обработчики событий для всех кнопок с классом `slider-btn`.
 * При нажатии на кнопку добавляется класс `press`, который затем удаляется через 300 миллисекунд.
 */
function _addSwiperControlsClick() {
  const buttonsSlider = document.querySelectorAll(".slider-btn");
  buttonsSlider.forEach((button) => {
    button.addEventListener("click", () => {
      button.classList.add("press");

      setTimeout(() => {
        button.classList.remove("press");
      }, 300);
    });
  });
}

function initSwipers(swiperClassname = "article-list", config = {}) {
  const swiperElements = Array.from(document.getElementsByClassName(swiperClassname));
  const swipers = swiperElements.map(swiperElement => _getSwiper(swiperElement, config));
  swipers.forEach((swiper) => {
    if (swiper.init) swiper.init();
  });
  _addSwiperControlsClick();
  return swipers;
}

export default initSwipers;